import en from './assets/lang/en.json';
import zh from './assets/lang/zh.json';
import ja from './assets/lang/ja.json';

export default defineI18nConfig(() => ({
  legacy: false,  // 是否兼容之前
  fallbackLocale: 'zh',  // 区配不到的语言就用en
  messages: {
    zh: zh,
    en: en,
    ja: ja,
  }
}))
